import { render, staticRenderFns } from "./BatchImageUpload.vue?vue&type=template&id=2dd47fb5&scoped=true"
import script from "./BatchImageUpload.vue?vue&type=script&lang=js"
export * from "./BatchImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd47fb5",
  null
  
)

export default component.exports